import { useState } from "react";
import { Lock, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { settingsApi } from "../../lib/adminSettings";

export default function TwoFAGate({ onVerified }) {
  const [step, setStep] = useState("idle");
  const [code, setCode] = useState("");
  const [destination, setDestination] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const requestCode = async () => {
    setSubmitting(true);
    try {
      const res = await settingsApi.request();
      setDestination(res.data.destination);
      setStep("sent");
      toast.success(`Código enviado a ${res.data.destination}`);
    } catch {
      toast.error("Error al enviar código");
    } finally { setSubmitting(false); }
  };

  const verify = async () => {
    if (!/^\d{6}$/.test(code)) return toast.error("Introduce un código de 6 dígitos");
    setSubmitting(true);
    try {
      await settingsApi.verify(code);
      toast.success("Verificación correcta. Acceso por 30 min.");
      onVerified();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Código incorrecto");
    } finally { setSubmitting(false); }
  };

  return (
    <div className="max-w-md mx-auto">
      <div className="sc-card rounded-md p-8 text-center">
        <div className="w-14 h-14 rounded-full bg-[#FFC107]/10 border border-[#FFC107]/30 flex items-center justify-center mx-auto mb-5">
          <Lock className="w-6 h-6 text-[#FFC107]" />
        </div>
        <h2 className="font-display font-bold text-2xl mb-2">Verificación necesaria</h2>
        <p className="text-sm text-[#A1A1AA] mb-6">
          La configuración de tarifas requiere verificación 2FA. Te enviamos un código de 6 dígitos a tu email.
        </p>

        {step === "idle" && (
          <button
            onClick={requestCode}
            disabled={submitting}
            className="btn-amber px-6 py-3 rounded-md font-semibold flex items-center justify-center gap-2 mx-auto"
            data-testid="2fa-request-btn"
          >
            {submitting ? <Loader2 className="w-4 h-4 animate-spin" /> : "Enviar código a mi email"}
          </button>
        )}

        {step === "sent" && (
          <>
            <p className="text-xs text-[#71717A] mb-4">
              Código enviado a <span className="text-white">{destination}</span>. Revisa tu bandeja (también spam).
            </p>
            <input
              type="text"
              inputMode="numeric"
              maxLength={6}
              value={code}
              onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))}
              placeholder="123456"
              className="w-full bg-[#141414] border border-white/10 rounded-md px-4 py-4 text-center text-2xl tracking-[0.4em] font-mono focus:border-[#FFC107] outline-none mb-4"
              data-testid="2fa-code-input"
              autoFocus
            />
            <div className="flex gap-2">
              <button
                onClick={() => { setStep("idle"); setCode(""); }}
                className="btn-outline px-4 py-2.5 rounded-md text-sm font-medium flex-1"
                data-testid="2fa-resend-btn"
              >
                Volver
              </button>
              <button
                onClick={verify}
                disabled={submitting || code.length !== 6}
                className="btn-amber px-4 py-2.5 rounded-md text-sm font-semibold flex-1 disabled:opacity-40 flex items-center justify-center gap-2"
                data-testid="2fa-verify-btn"
              >
                {submitting ? <Loader2 className="w-4 h-4 animate-spin" /> : "Verificar"}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
